import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=323a99f7"
import script from "./Hints.vue?vue&type=script&lang=ts"
export * from "./Hints.vue?vue&type=script&lang=ts"
import style0 from "./Hints.vue?vue&type=style&index=0&id=323a99f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_dff85fdde67eb76c2c1cde02c7c65e15/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports